<input
  #fileInput
  type="file"
  class="file-input-hidden"
  [accept]="accept()"
  [multiple]="multiple()"
  [disabled]="disabled()"
  (change)="onFileInputChange($event)"
  aria-hidden="true"
  tabindex="-1"
/>

<div
  class="dropzone-trigger"
  [class.is-drag-over]="isDragOver()"
  [class.is-disabled]="disabled()"
  role="button"
  [tabindex]="disabled() ? -1 : 0"
  [attr.aria-disabled]="disabled()"
  [attr.aria-label]="attachText()"
  (click)="onTriggerClick()"
  (keydown)="onTriggerKeydown($event)"
  (dragover)="onDragOver($event)"
  (dragleave)="onDragLeave($event)"
  (drop)="onDrop($event)"
>
  <umss-icon [name]="iconName()" size="24px" [color]="iconColor()" />
  <span class="attach-text">{{ attachText() }}</span>
</div>

@if (hasFiles()) {
  <ul class="files-list" role="list" aria-label="Attached files">
    @for (item of items(); track item.id) {
      <li class="file-item">
        <umss-icon
          [name]="getFileIcon(item.file)"
          size="20px"
          color="#4361EE"
          class="file-type-icon"
          aria-hidden="true"
        />

        <span class="file-name" [title]="item.file.name">{{
          item.file.name
        }}</span>

        <span class="file-size">{{ formatFileSize(item.file.size) }}</span>

        <button
          class="remove-btn"
          type="button"
          [attr.aria-label]="'Remove ' + item.file.name"
          (click)="removeFile(item.id)"
        >
          <umss-icon name="phosphorX" size="14px" />
        </button>
      </li>
    }
  </ul>
}
